import { useEffect, useState } from "preact/hooks";

export const useOrdersProgressBar = (props) => {
    const {orderStatus} = props;

    // 1: inactive; 2: active; 3: checked
    const [stepInfos, setStepInfos] = useState({
        first: 3,
        second: 2,
        third: 1,
    });

    const doneList = ['complete', 'finished'];

    const processingList = [
        'partially_applied', 
        'partially_scheduled', 
        'processing', 
        'scheduled', 
        'pending', 
        'processing_cancel', 
        'canceled'
    ];

    useEffect(() => {
        if(doneList.includes(orderStatus)) {
            setStepInfos((prevState) => ({
                ...prevState,
                first: 3,
                second: 3,
                third: 3,
            }));
        }

        if(processingList.includes(orderStatus)) {
            setStepInfos((prevState) => ({
                ...prevState,
                first: 3,
                second: 2,
                third: 1,
            }));
        }

    }, [orderStatus]);

    return {
        stepInfos
    }
};